/**
 * @file 处方打印
 * print('url')
 * 多张图片：
 * print([url1, url2])
 * */
import Vue from 'vue';
import PrintImg from './index.vue';
import { Message } from 'element-ui';
import debounce from 'lodash/debounce';

const PrintImageFactory = Vue.extend(PrintImg);

let instance = null;

const replaceProtocol = url => {
  return url.replace(/^http(s|):/, '');
};

/**
 * @param {String | Array} source
 * */
const printImg = debounce(
  (source, cb) => {
    let propImageData = source;
    if (!Array.isArray(source)) {
      propImageData = [source];
    }
    if (propImageData.length === 0) return Message.warning('请选择图片');
    if (!instance) {
      instance = new PrintImageFactory();
      instance.vm = instance.$mount();
      document.body.appendChild(instance.vm.$el);
    }
    // 提取出图片地址
    const propsImageSrc = propImageData.map(v =>
      typeof v === 'string' ? replaceProtocol(v) : replaceProtocol(v.prescriptionImg)
    );
    console.log(propsImageSrc);
    instance.init(propsImageSrc, cb);
  },
  300,
  { trailing: false, leading: true }
);

export default printImg;
